import { API_ENDPOINTS, createApiUrl, ServiceType } from 'src/contstant/apiEndpoints';
import { apiClient } from '../apiClient';
import {
  CreatePermissionRequest,
  CreatePermissionResponse,
  ListPermissionRequest,
  ListPermissionResponse,
  Permission,
  UpdatePermissionRequest,
  UpdatePermissionResponse,
} from 'src/types/orbit/Permission';

export const permissionService = {
  getAll: (data: ListPermissionRequest) => {
    return apiClient.get<ListPermissionResponse>(
      ServiceType.ORBIT,
      createApiUrl(API_ENDPOINTS.ORBIT_SERVERICE.PERMISSION.ALL(data.programId)),
      data,
    );
  },

  getById: (programId: string, permissionId: string) => {
    return apiClient.get<Permission>(
      ServiceType.ORBIT,
      createApiUrl(
        API_ENDPOINTS.ORBIT_SERVERICE.PERMISSION.BY_ID(programId, permissionId),
      ),
    );
  },

  create: (data: CreatePermissionRequest) => {
    return apiClient.post<CreatePermissionResponse, CreatePermissionRequest>(
      ServiceType.ORBIT,
      createApiUrl(API_ENDPOINTS.ORBIT_SERVERICE.PERMISSION.CREATE(data.programId)),
      data,
    );
  },

  update: (data: UpdatePermissionRequest) => {
    return apiClient.put<UpdatePermissionResponse, UpdatePermissionRequest>(
      ServiceType.ORBIT,
      createApiUrl(
        API_ENDPOINTS.ORBIT_SERVERICE.PERMISSION.UPDATE(
          data.programId,
          data.permissionId,
        ),
      ),
      data,
    );
  },

  delete: (programId: string, permissionId: string) => {
    return apiClient.delete<void>(
      ServiceType.ORBIT,
      createApiUrl(
        API_ENDPOINTS.ORBIT_SERVERICE.PERMISSION.DELETE(programId, permissionId),
      ),
    );
  },
};
